import React from "react";

import "./css/categoriesAdd.css";

import { Link } from "react-router-dom";
import * as ROUTES from "../../../../constants/routes";

import {
  TextField,
  Fade,
  FormHelperText,
  Button,
  CircularProgress,
  Snackbar,
  Chip,
} from "@material-ui/core";

import { AttachFile } from "@material-ui/icons";

import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CategoryAddForm = (props) => {
  const {
    categoryCode,
    categoryTitle,
    categoryDescription,
    categoryOrder,
    categoryCodeError,
    categoryTitleError,
    categoryDescriptionError,
    categoryIconError,
    fileName,
    iconPreview,
    toggleAlert,
    messageType,
    messageAlert,
    toggleActionAlert,
    isLoading,
  } = props.state;

  return (
    <>
      <div className={"categoriesAddRoot"}>
        <form onSubmit={props.onSubmit()}>
          <div className={"categoriesAddContainer"}>
            <label className={"categoriesAddHeader"}>Add New Category</label>

            {toggleAlert && (
              <>
                <MuiAlert elevation={1} variant="filled" severity={messageType}>
                  {messageAlert}
                </MuiAlert>
                <br />
              </>
            )}

            <label className={"categoriesAddTitle"}>Category Code</label>

            <TextField
              name="categoryCode"
              inputProps={{ className: "categoriesAddTextBox" }}
              variant="outlined"
              value={categoryCode}
              onChange={props.onChange()}
              placeholder="Category code..."
              autoComplete="off"
              required
            />
            <Fade in={true}>
              <FormHelperText style={{ color: "red" }}>
                {categoryCodeError}
              </FormHelperText>
            </Fade>

            <br />
            <label className={"categoriesAddTitle"}>Category Title</label>

            <TextField
              name="categoryTitle"
              inputProps={{ className: "categoriesAddTextBox" }}
              variant="outlined"
              value={categoryTitle}
              onChange={props.onChange()}
              placeholder="Category title..."
              autoComplete="off"
              required
            />
            <Fade in={true}>
              <FormHelperText style={{ color: "red" }}>
                {categoryTitleError}
              </FormHelperText>
            </Fade>

            <br />
            <label className={"categoriesAddTitle"}>Description</label>

            <TextField
              name="categoryDescription"
              inputProps={{ className: "categoriesAddDescription" }}
              variant="outlined"
              value={categoryDescription}
              onChange={props.onChange()}
              placeholder="Category description..."
              autoComplete="off"
              multiline
              rows={8}
            />
            <Fade in={true}>
              <FormHelperText style={{ color: "red" }}>
                {categoryDescriptionError}
              </FormHelperText>
            </Fade>

            <br />
            <label className={"categoriesAddTitle"}>Display Order</label>

            <TextField
              name="categoryOrder"
              inputProps={{ className: "categoriesAddTextBox", min: 1 }}
              variant="outlined"
              type="number"
              value={categoryOrder}
              onChange={props.onChange()}
              placeholder="1, 2, 3..."
              autoComplete="off"
            />
            <FormHelperText style={{ color: "gray" }}>
              Lower numbers appear first. Leave empty to appear last.
            </FormHelperText>

            <br />
            <label className={"categoriesAddTitle"}>Icon</label>
            <input
              name="categoryIcon"
              type="file"
              accept=".jpg,.jpeg,.png"
              className={"categoriesAddUpload"}
              onChange={props.onChange()}
            />
            <FormHelperText style={{ color: "gray" }}>
              Min: 50x50px - Max: 1000x1000px (Width x Height)
            </FormHelperText>

            <Fade in={true}>
              <FormHelperText style={{ color: "red" }}>
                {categoryIconError}
              </FormHelperText>
            </Fade>

            {fileName && (
              <div>
                <Chip
                  icon={<AttachFile className={"categoriesAddUploadIconSize"} />}
                  label={fileName}
                  className={"categoriesAddUploadChip"}
                  color="secondary"
                />
              </div>
            )}

            {iconPreview && (
              <div className={"categoriesAddIconPreview"}>
                <img
                  src={iconPreview}
                  alt="Category icon preview"
                  className={"categoriesAddIconImage"}
                />
              </div>
            )}

            <br />
            <div>
              <Button
                component={Link}
                to={ROUTES.CATEGORIES_LIST}
                style={{ pointerEvents: isLoading ? "none" : "all" }}
                className={"categoriesAddCancelButton"}
              >
                Cancel
              </Button>
              {!isLoading ? (
                <Button type="submit" className={"categoriesAddAddButton"}>
                  Add Category
                </Button>
              ) : (
                <CircularProgress className={"categoriesAddLoading"} />
              )}
            </div>
          </div>
        </form>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={3000}
        open={toggleActionAlert}
        onClose={props.onhandleClose()}
      >
        <Alert onClose={props.onhandleClose()} severity={messageType}>
          {messageAlert}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CategoryAddForm;
